export default function ls (context, args, flags) {
  const folder = context.getWD()

  let list = ''

  Object.keys(folder).forEach(item => {
    if (folder[item].type === 'folder') list += `<span class="fs-folder">${item}</span> `
    if (folder[item].type === 'txt') list += `<span class="fs-txt">${item}</span> `
  })

  return list
}



// WEBPACK FOOTER //
// ./src/natos/commands/ls.js